import BaseClient from "./BaseClient";

export default class MemoServiceClient extends BaseClient {
    constructor(tenantId: string) {
        super(null, tenantId, true, "cus");
    }
    public async getCustomerMemos(customerId: string): Promise<{ memos: Memo[] }> {
        const response = await this.get(`/api/proxy/cus/memo-service/customers/${customerId}/memos`);
        return await this.handleResponse<{ memos: Memo[] }>(response, true);
    }

    public async addCustomerMemo(customerId: string, memo: CreateMemoRequest): Promise<CreateMemoResponse> {
        const response = await this.post(`/api/proxy/cus/memo-service/customers/${customerId}/memos`, memo);
        return await this.handleResponse<Memo>(response);
    }

    public async getAccountMemos(
        accountId: string,
        channel?: string,
        categoryCode?: string,
        createdBy?: string,
        startDate?: string,
        endDate?: string
    ): Promise<{ memos: Memo[] }> {
        const queryParams = new URLSearchParams();

        if (channel) queryParams.append('channel', channel);
        if (categoryCode) queryParams.append('categoryCode', categoryCode);
        if (createdBy) queryParams.append('createdBy', createdBy);
        if (startDate) queryParams.append('startDate', startDate);
        if (endDate) queryParams.append('endDate', endDate);

        const queryString = queryParams.toString();
        const url = `/api/proxy/cus/memo-service/accounts/${accountId}/memos${queryString ? `?${queryString}` : ''}`;

        const response = await this.get(url);
        return await this.handleResponse<{ memos: Memo[] }>(response, true);
    }

    public async addAccountMemo(accountId: string, memo: CreateAccountMemoRequest, headers?: {}): Promise<CreateMemoResponse> {
        const response = await this.post(`/api/proxy/cus/memo-service/accounts/${accountId}/memos`, memo, headers);
        return await this.handleResponse<Memo>(response);
    }

    public async deleteAccountMemo(accountId: string, memoId: string): Promise<string> {
        const response = await this.delete(`/api/proxy/cus/memo-service/accounts/${accountId}/memos/${memoId}`);
        return await this.handleResponse<string>(response);
    }
}

export const useMemoService = (tenantId: string): MemoServiceClient => {
    return new MemoServiceClient(tenantId);
};


export type Memo = {
    memoId: string,
    customerId: string,
    note: string,
    createdDate: string,
    createdBy: string,
    categoryCode: string
}

type CreateMemoRequest = {
    note: string;
}

type CreateAccountMemoRequest = {
    note: string;
    categoryCode: string;
}

type CreateMemoResponse = {
    memoId: string;
}